import React from 'react';

import FilterDatepickerPair from 'components/search_sidebar/filter_datepicker_pair';
import { CalendarPortal } from 'components/form/managed_input/date_input';

import type { Filters } from './types';
import { FormLabel } from 'react-bootstrap-5';

type Slice = Pick<Filters, 'dateRange'>;
interface Props extends Slice {
  onChange: (changes: Slice) => void;
}

export default function ActivityDateFilter({ dateRange, onChange }: Props) {
  return (
    <div className="flex-grow-1">
      <FormLabel>Date Range</FormLabel>
      <FilterDatepickerPair
        filter={dateRange}
        inputsOnly
        maxPlaceholder="To"
        minPlaceholder="From"
        popperContainer={CalendarPortal}
        valueKeys={['min', 'max']}
        onChange={(value, key) => onChange({ dateRange: { ...dateRange, [key]: value } })}
      />
    </div>
  );
}
